import { render } from "./StatsStrip.vue?vue&type=template&id=73e30f2f&scoped=true"
import script from "./StatsStrip.vue?vue&type=script&lang=js"
export * from "./StatsStrip.vue?vue&type=script&lang=js"

import "./StatsStrip.vue?vue&type=style&index=0&id=73e30f2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e30f2f"]])

export default __exports__